export const PERCENTS = 'PERCENTS'
export const CURRENCY = 'CURRENCY'
export const DAYS_OF_WEEK = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']
export const KASSE = 'KASSE'
export const SHOP = 'SHOP'
